import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNumberPages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.6 12.4V9.88c0-1.008 0-1.512-.196-1.897a1.8 1.8 0 0 0-.787-.787C18.232 7 17.728 7 16.72 7H9.88c-1.008 0-1.512 0-1.897.196a1.8 1.8 0 0 0-.787.787C7 8.368 7 8.872 7 9.88v6.84c0 1.008 0 1.512.196 1.897a1.8 1.8 0 0 0 .787.787c.385.196.889.196 1.897.196h2.52m2.88 5.4h6.84c1.008 0 1.512 0 1.897-.196a1.8 1.8 0 0 0 .787-.787c.196-.385.196-.889.196-1.897v-6.84c0-1.008 0-1.512-.196-1.897a1.8 1.8 0 0 0-.787-.787c-.385-.196-.889-.196-1.897-.196h-6.84c-1.008 0-1.512 0-1.897.196a1.8 1.8 0 0 0-.787.787c-.196.385-.196.889-.196 1.897v6.84c0 1.008 0 1.512.196 1.897a1.8 1.8 0 0 0 .787.787c.385.196.889.196 1.897.196"
    />
    <path
      fill="#fff"
      d="M17.728 22.006a.04.04 0 0 0 0 .045q.014.01.04.011h4.096q.136 0 .136.113v.712q0 .113-.136.113h-5.7q-.137 0-.137-.113v-.69q0-.078.068-.135.463-.44 2.123-2.068l.939-.937q1.265-1.255 1.265-1.944a1 1 0 0 0-.436-.848q-.42-.327-1.129-.327-.707 0-1.13.327a1 1 0 0 0-.407.86v.338q0 .113-.136.113h-1.048q-.136 0-.136-.113v-.486q.027-.587.395-1.04.38-.45 1.02-.688A4 4 0 0 1 18.857 15q.87 0 1.524.271.652.272 1.007.746.353.474.353 1.073 0 .939-1.224 2.215-.544.576-1.293 1.3-.747.711-1.496 1.4"
    />
  </svg>
);
export default SvgNumberPages;
